import { useTranslation } from 'react-i18next'; // assuming you're using i18next
import { DASHBOARD_ORDER_FILTER_VALUES } from '../DashboardOrderListFilter';

export const useOrderListFilterValues = () => {
  const { t } = useTranslation();

  const filterItems = [
    {
      title: t('order.status_UNASSIGNED'),
      value: DASHBOARD_ORDER_FILTER_VALUES.UNASSIGNED,
    },
    {
      title: t('order.status_IN_DELIVERY_ALTERNATE_TRANSLATION'),
      value: DASHBOARD_ORDER_FILTER_VALUES.ON_THE_WAY,
    },
    {
      title: t('order.status_DELIVERED'),
      value: DASHBOARD_ORDER_FILTER_VALUES.DELIVERED,
    },
    {
      title: t('order.filter_all'),
      value: DASHBOARD_ORDER_FILTER_VALUES.ALL,
    },
  ];

  const getOrderListFilterItemByValue = (value: DASHBOARD_ORDER_FILTER_VALUES) => {
    return filterItems.find((item) => item.value === value);
  };

  return { filterItems, getOrderListFilterItemByValue };
};
